import React from 'react'
import { useAppDispatch } from '@core/Store/hooks'
import { setUserPromoData } from '@mobi/betslip/Store/Workflow'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { fetchCampaignsAsync } from '@core/State/UserAccount/async-signals'

export const useAccountCampaignsSync = (isOpen: boolean) => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (!isOpen) return

    const subscription = userAccountState$.subscribe(state => {
      const { campaigns, bonusBetBalance, bonusCashBalance } = state

      if (!state.isLoggedIn) {
        dispatch(
          setUserPromoData({
            bonusBetBalance: 0,
            bonusCashBalance: 0,
            campaigns: [],
            bonusCashCampaigns: [],
          })
        )
        return
      }

      const currentDate = new Date()

      const filteredCampaigns =
        campaigns
          ?.toArray()
          .filter(campaign => new Date(campaign.rewardExpiry) > currentDate)
          .sort(
            (a, b) => new Date(a.rewardExpiry).getTime() - new Date(b.rewardExpiry).getTime()
          ) ?? []

      const bonusCashCampaigns =
        campaigns
          ?.toArray()
          .filter(c => c.rewardType === 'BonusCashReward' && new Date(c.rewardExpiry) > currentDate)
          .sort(
            (a, b) => new Date(a.rewardExpiry).getTime() - new Date(b.rewardExpiry).getTime()
          ) ?? []

      dispatch(
        setUserPromoData({
          bonusBetBalance: bonusBetBalance as number,
          bonusCashBalance: bonusCashBalance as number,
          bonusCashCampaigns: bonusCashCampaigns,
          campaigns: filteredCampaigns,
        })
      )
    })

    return () => {
      subscription.dispose()
    }
  }, [isOpen, dispatch])

  React.useEffect(() => {
    if (isOpen) fetchCampaignsAsync()
  }, [isOpen])
}
